import { Box, Typography, Container } from "@mui/material";
import factory from "./../../assets/factory.png";
const brandBlue = "#1a237e";
const brandRed = "#d50000";


export default function CompanyOverview() {
  const overviewImage = factory;

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f9f9ff" }}>
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch", // ⭐ Important for equal height
            gap: 5,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* LEFT - IMAGE */}
          <Box
            sx={{
              flex: 1,
              borderRadius: 4,
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              display: "flex",
            }}
          >
            <img
              src={overviewImage}
              alt="Company Overview"
              style={{
                width: "100%",
                height: "100%", // ⭐ Fill full available height
                objectFit: "cover",
              }}
            />
          </Box>

          {/* RIGHT - TEXT */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center", // vertically center text
            }}
          >
            <Typography
              variant="h4"
              fontWeight={800}
              sx={{
                mb: 2,
                color: brandBlue,
                fontSize: { xs: "1.8rem", md: "2.3rem" },
              }}
            >
              Company Overview
            </Typography>

            <Box
              sx={{
                width: "70px",
                height: "4px",
                background: brandRed,
                borderRadius: 2,
                mb: 3,
              }}
            />

            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.8,
                fontSize: "1.05rem",
              }}
            >

              Burj Al Yarmouk Industries LLC is a privately owned industrial engineering and manufacturing company based in Sharjah, UAE, established in 2015. With over 25 years of collective industry experience, we specialize in the design, development, and manufacturing of acoustic generator enclosures, fuel tanks, lifting frames, structural metal works, reservoirs, hoppers, and customized metal fabrication solutions.
              <br /><br />
              We serve regional and international clients across power generation, oil & gas, industrial manufacturing, utilities, and engineering sectors.
              <br /><br />
              Our ISO-certified Quality Management System ensures every product meets the highest global standards, including:
              ISO 9001:2015 • ISO 14001:2015 • ISO 45001:2018
              <br /><br />
              We are committed to innovation, engineering excellence, and delivering high-performance products that stand the test of time.

            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
